import { type MCPServerInfo } from '../../types';

const MixpanelServer: MCPServerInfo = {
  serverId: 'MIXPANEL',
  name: 'Mixpanel',
  slug: 'mixpanel',
  description:
    'Mixpanel MCP Server - Analyze product and replay data using conversational AI. Query events, session replays, funnels, and user behavior through natural language.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.mixpanel.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default MixpanelServer;
